export default __webpack_public_path__ + "static/media/train01.4becd002.jpg";